module.exports = __webpack_public_path__ + "img/vertical_6_6_8023.3a68c997.png";